import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import "react-table/react-table.css";
import './MultipleChoiceOtherOptionsModal.css';

const MultipleChoiceOtherOptionsModal = ({ answerId, toggle, isOpen, questionTitle, options, onChangeMultipleChoicesSelectedOptions }) => {

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="modal-body" centered={true} style={{ maxWidth: '85%' }}>
            <ModalHeader toggle={toggle}>{questionTitle}</ModalHeader>

            <ModalBody>
                <p>Opções selecionadas:</p>
                <ul className='flex pl-none'>
                {options?.filter(option => option.isSelected === true).map(option => (
                    <li key={`${option.id}-${option.value}`} onClick={() => onChangeMultipleChoicesSelectedOptions(answerId, option.value, false)} className="mutiple-choice-option-tag-selected pointer">
                        {option.value}
                    </li>
                    ))}
                </ul>

                <p>Clique para selecionar outras opções de resposta:</p>
                <ul className='flex pl-none'>
                    {options?.filter(option => option.isSelected === false).map(option => (
                        <li key={`${option.id}-${option.value}`} onClick={() => onChangeMultipleChoicesSelectedOptions(answerId, option.value, true)} className="mutiple-choice-option-tag pointer">{option.value}</li>
                    ))}
                </ul>

                <small>Clique em uma opção selecionada para removê-la</small>
            </ModalBody>
        </Modal>
    );
}

export default MultipleChoiceOtherOptionsModal;